import React from "react";
import Header from "../../Partials/Header/Header";
import Slideshow from "../../Components/Slideshow/Slideshow";


import Footer from "../../Partials/Footer/Footer";

export default class Material extends React.Component {
    render() {
        return (
            <div className="integrator-wrapper">
                <Header />
                <Slideshow />
                <Footer />
            </div>
        );
    }
}